var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9668 1.49967V2.66634C3.9668 3.95501 5.01147 4.99967 6.30013 4.99967H13.3001C14.5888 4.99967 15.6335 3.95501 15.6335 2.66634V1.49967H16.8001C18.0888 1.49967 19.1335 2.54434 19.1335 3.83301V16.6663C19.1335 20.5323 15.9994 23.6663 12.1335 23.6663H2.80013C1.51147 23.6663 0.466797 22.6217 0.466797 21.333V3.83301C0.466797 2.54434 1.51147 1.49967 2.80013 1.49967H3.9668ZM9.80013 14.333H6.30013C5.6558 14.333 5.13346 14.8553 5.13346 15.4997C5.13346 16.144 5.6558 16.6663 6.30013 16.6663H9.80013C10.4445 16.6663 10.9668 16.144 10.9668 15.4997C10.9668 14.8553 10.4445 14.333 9.80013 14.333ZM13.3001 9.66634H6.30013C5.6558 9.66634 5.13346 10.1887 5.13346 10.833C5.13346 11.4313 5.58385 11.9244 6.16407 11.9918L6.30013 11.9997H13.3001C13.9445 11.9997 14.4668 11.4774 14.4668 10.833C14.4668 10.1887 13.9445 9.66634 13.3001 9.66634ZM12.1335 0.333008C12.7778 0.333008 13.3001 0.855348 13.3001 1.49967C13.3001 2.09798 12.8498 2.5911 12.2695 2.65849L12.1335 2.66634H7.4668C6.82247 2.66634 6.30013 2.144 6.30013 1.49967C6.30013 0.901371 6.75051 0.40825 7.33074 0.340857L7.4668 0.333008H12.1335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.4a89ee6697bff171f85d5ca10ac2677c.svg";
export { ForwardRef as ReactComponent };